import { useEffect, useState } from 'react';
import { useFetcher } from '@remix-run/react';

export function useFetcherWithReset<T = any | undefined>() {
  const fetcher = useFetcher<T>();
  const [data, setData] = useState<T | undefined>(fetcher.data as T);

  useEffect(() => {
    if (fetcher.state === 'idle') {
      setData(fetcher.data as T);
    }
  }, [fetcher.state, fetcher.data]);

  return {
    ...fetcher,
    data,
    reset: () => setData(undefined),
  };
}
